import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { Observable, Subscription, catchError, debounceTime, distinctUntilChanged, filter, of, switchMap, tap } from 'rxjs';
import { PersonRoleEnum } from '../../../Models/OtherClasses';
import { AuthService } from '../../../RoutingAuth/auth.service';
import { ConfigService } from '../../../Services/ConfigService';
import { PersonService } from '../../../Services/Custom/ServicePerson';
import { SearchService } from '../../../Services/Custom/ServiceSearch';
import { DialogService } from '../../../Services/DialogService';
import { ScannerPopUpComponent } from '../../PopUps/ScannerPopUpComponent';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css'],
	
})
export class HeaderComponent implements OnInit, OnDestroy {

	name: string;
	customerName = '';
	userID: System.Guid;
	isSuperAdmin: boolean;
	isDeveloper: boolean;
	isAuthenticated: boolean;
	compSub: Subscription;
	subscription: Subscription;
	isAdmin: boolean = false;
	isEmployee: boolean = false;
	cacheBuster: string = '';
	downloadtoken: string = '';
	isMenuCollapsed: boolean = true;
	isSupportMode = false;

	private hubConnection!: signalR.HubConnection;
	private stopConnection() {
		var thisHolder = this;
		if (this.hubConnection && signalR.HubConnectionState.Connected == this.hubConnection.state) {
			var promises: Promise<any>[] = [];
			promises.push(thisHolder.hubConnection.invoke("LeaveGroup", "Person" + this.configData.userID()));
			Promise.all(promises)
				.then(() => {
					thisHolder.hubConnection.stop().then(() => {
						thisHolder.hubConnection = undefined;
					});
				});
		}
	}
	public startConnection() {
		var thisHolder = this;

		thisHolder.hubConnection = new signalR.HubConnectionBuilder()
			.withUrl(thisHolder.configData.baseUrl + 'Hub/Person')
			.build();

		thisHolder.hubConnection
			.start()
			.then(() => console.log('Connection started'))
			.then(() => {
				thisHolder.hubConnection.invoke("JoinGroup", "Person" + this.configData.userID());
				thisHolder.hubConnection.on('itemUpdate', (data) => {
					var id = thisHolder.configData.userID();
					if (!thisHolder.configData.IsEmptyGuid(id)) {
						thisHolder.update();

					}
				});
			})
			.catch(err => console.log('Error while starting connection: ' + err));

		
	}

	constructor(
		private authService: AuthService,
		private configData: ConfigService,
		private dialogService: DialogService,
		private myModalService: NgbModal,
		private mySearchService: SearchService,
		private myPersonService: PersonService,
		private myRouter: Router
	) {
	}

	compLogo = '';

	ngOnInit() {


		var thisHolder = this;

		this.subscription = this.authService.authNavStatus$.subscribe((status: boolean) => {
			thisHolder.isAuthenticated = status;
			this.loadData(status);
		});

		this.compSub = this.authService.companyChanged$.subscribe((status: boolean) => {
			this.changeCompany();
		});

		this.loadData(this.configData.isLoggedIn());

		this.startConnection();
	}

	changeCompany() {
		this.compLogo =
			this.authService.configData.apiBaseUrl()
			+ "api/v1/Company/Logo/"
			+ this.authService.configData.companyID;
	}
	loadData(isAuthed: boolean) {
		this.changeCompany();

		var thisHolder = this;
		if (isAuthed) {
			thisHolder.name = thisHolder.configData.name();
			thisHolder.customerName = thisHolder.configData.customerName();
			thisHolder.userID = thisHolder.configData.userID();
			thisHolder.cacheBuster = DateTime.local().millisecond.toString();
			thisHolder.isSupportMode = this.configData.isSupportMode();
			//thisHolder.startConnection();
			
		} else {
			thisHolder.name = '';
			thisHolder.customerName = '';
			thisHolder.userID = '';
			thisHolder.isSupportMode = false;
			this.stopConnection();
		}
		thisHolder.isEmployee = thisHolder.configData.isEmployee();
		thisHolder.isAdmin = thisHolder.configData.IsUserInRole(PersonRoleEnum.ADMIN);
		thisHolder.isSuperAdmin = thisHolder.configData.IsUserInRole(PersonRoleEnum.SUPERADMIN);
		thisHolder.isDeveloper = thisHolder.configData.IsUserInRole(PersonRoleEnum.DEVELOPER);
	}

	removeSupport() {
		var thisHolder = this;
		if (thisHolder.isSupportMode) {
			thisHolder.myPersonService.removeSupportMode()
				.subscribe(val => {
					var msg = 'Support Mode Disabled';
					if (!this.isEmployee) {
						msg = 'Cancelled Account Viewing';
					}
					thisHolder.dialogService.message(msg, 'Account Viewing')
						.finally(() => {
							thisHolder.myRouter.navigate(['support-callback']);
						});
				});
		}
	}
	changeMenuWidth() {
		this.configData.menuChangedManually();
	}
	isSearching = false;
	search = (text$: Observable<string>) =>
		text$.pipe(
			filter(term => term.length > 2),
			debounceTime(600),
			distinctUntilChanged(),
			tap(a => this.isSearching = true),
			switchMap(term => {
				var searchObj: TooBig4Car.Logic.SearchVM = {
					SearchText: term
				};
				return this.mySearchService.search(searchObj).pipe(
					tap((col) => {
						if (!col || !col.length) {
							col.push({ SearchName: 'No Results'});
						}
					}),
					catchError(() => {
						this.isSearching = false;
						return of([]);
					})
				);
			})
		)

	searchFormatter = (result: TooBig4Car.Logic.SearchResult) => {
		this.isSearching = false;
		return result.SearchName;
	}

	searchText: string = '';

	selectItem(evt: NgbTypeaheadSelectItemEvent) {
		if (evt && evt.item) {
			evt.preventDefault();
			this.searchText = '';
			this.goToSearchResult(evt.item);
		}
	}

	goToSearchResult(result: TooBig4Car.Logic.SearchResult) {
		if (result) {
			switch (result.TypeObject) {
				case "StorageSpace":
					this.myRouter.navigateByUrl('/ang/Storage/Location/Space/' + result.ID + '/Details');
					return;
				case "PickupDelivery":
					this.myRouter.navigateByUrl('/ang/PickupDelivery/' + result.ID);
					return;
				case "PropertyItem":
					this.myRouter.navigateByUrl('/ang/Storage/Items/' + result.ID);
					return;
				case "CustomerAccount":
					this.myRouter.navigateByUrl('/ang/CustomerAccount/' + result.ID);
					return;
			}
		}
	}
	qrScan2() {
		const modalRef = this.myModalService.open(ScannerPopUpComponent, { size: 'lg' });
		const scannerComponent = modalRef.componentInstance as ScannerPopUpComponent;


		scannerComponent.visible = true;
		scannerComponent.scanResult.subscribe((val: string) => {
			if (val && val.length > 4) {
				var searchObj: TooBig4Car.Logic.SearchVM = {
					SearchText: val
				};
				this.mySearchService.search(searchObj)
					.subscribe(col => {
						if (col.length) {
							this.goToSearchResult(col[0]);
							modalRef.close();
						}
					});
			}
		});

	}

	logIn() {
		this.authService.login();
	}
	update() {
		this.authService.updateUserInfo();
	}
	async signout() {
		this.authService.clearUserInfo();
		await this.authService.signout();
	}

	ngOnDestroy() {
		// prevent memory leak when component is destroyed
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
		if (this.compSub) {
			this.compSub.unsubscribe();
		}
		this.stopConnection();
	}

}
